import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const personalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings',
	path: '/secure/ViewPersonalSettings.jspa',
};
